module.exports = __webpack_public_path__ + "img/psd.c85ec153.svg";